module.exports = __webpack_public_path__ + "img/part4.250de1c6.jpeg";